import { getSharedRootStore, hasFeatureFlag } from '@bringg-frontend/global-stores';

import { AUTOMATIONS_BOARD_UNREADABLE_PLACEHOLDER_FF } from '../consts';

export function isUnreadablePlaceholderEnabled(): boolean {
	const currentUser = getSharedRootStore()?.data?.usersStore?.currentUser;

	return Boolean(hasFeatureFlag(currentUser, AUTOMATIONS_BOARD_UNREADABLE_PLACEHOLDER_FF));
}
